export const PEAK_ESTIMATED_SHAPES = {
  NO_DATA: '-',
  SKEW_GAUSS: 'skew_gauss',
};
